import * as React from "react";

import { Checkbox as UiCheckbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

/**
 * Checkbox — Auswahlkästchen mit Beschriftung.
 *
 * Hülle um `<Checkbox>`; `onChange` liefert wie beim Primitive einen Boolean.
 */
const Checkbox = ({ label, className, checked, onChange, disabled }) => (
  <label
    className={cn(
      "flex items-start gap-[1rem] my-[0.6rem]",
      disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer",
    )}
  >
    <UiCheckbox
      checked={!!checked}
      onChange={disabled ? undefined : onChange}
      className="mt-[0.2rem]"
    />
    {label && (
      <span className={cn("text-[1.3rem] text-foreground break-words", className)}>
        {label}
      </span>
    )}
  </label>
);

export default Checkbox;
